module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    // API_URL: "http://localhost:3003",
    API_URL: "https://api.apihub.today",
  }
};
